/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
`
export default class EditIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" css={Color}>
        <g id="그룹_5426" data-name="그룹 5426" transform="translate(5384 109)">
          <rect id="사각형_5532" data-name="사각형 5532" width="17" height="17" transform="translate(-5384 -109)" fill="#fff" opacity="0"/>
          <path id="패스_5030" data-name="패스 5030" d="M24.49,14.833l-.981.981-2.451-2.455.981-.981a.541.541,0,0,1,.748,0l1.7,1.707A.53.53,0,0,1,24.49,14.833Zm-8.193,8.2L13.846,20.58l6.337-6.347,2.451,2.455ZM13.28,21.764,15.114,23.6l-2.554.72.72-2.557Zm12.085-8.553-1.7-1.707a1.8,1.8,0,0,0-2.494,0l-8.634,8.641a.594.594,0,0,0-.157.269l-1.3,4.634a.63.63,0,0,0,.157.605.759.759,0,0,0,.605.157l4.63-1.3a.594.594,0,0,0,.269-.157l8.628-8.641A1.77,1.77,0,0,0,25.365,13.211Z" transform="translate(-5394.052 -118.992)"/>
        </g>
      </svg>
    )
  }
}
